export default "__VITE_ASSET__CFYGzUei__"